import { Link, Box, Flex, Text, Button, Stack, Image } from "@chakra-ui/react";
import Logo from "../../assets/Logo.svg";

const About = (props: any) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      paddingTop={["3em", "3em", "3em", "5em"]}
      paddingBottom={["3em", "3em", "3em", "5em"]}
      bg="#161616"
      position="relative"
      {...props}
    >
      <Flex
        position="absolute"
        display={["none", "none", "block", "block", "block"]}
        // left="auto"
        top="50px"
        right="50px"
        // src="/about/neon.png"
      >
        <Text
          fontSize={["30px", "35px", "38px", "42px", "80px"]}
          fontWeight="900"
          fontFamily="'Clash Display', sans-serif"
          color="rgb(255,255,235)"
          textShadow="2px 2px 8px rgba(100, 210, 30, 0.8), -2px -2px 8px rgba(100, 210, 30, 0.8), 5px 5px 20px rgba(80, 200, 20, 0.8), -5px -5px 20px rgba(100, 200, 40, 0.8)"
          textTransform="uppercase"
          textAlign="center"
          lineHeight="96%"
          mb={6}
        >
          M<br/>A<br/>U<br/><br/>C<br/>L<br/>U<br/>B
        </Text>
      </Flex>
      {/* <Image
        position="absolute"
        width={["0%", "30%", "26%", "30%", "200px"]}
        display={["none", "none", "block", "block", "block"]}
        // left="auto"
        top="30px"
        left="0px"
        src={Logo}
      /> */}
      <Box
        maxWidth={["88vw", "86vw", "66vw", "66vw"]}
        textAlign="left"
        fontSize="15px"
        zIndex="2"
      >
        <Text
          fontFamily="'Clash Display', sans-serif"
          color="white"
          fontSize={["30px", "30px", "40px", "40px"]}
          lineHeight="120%"
          fontWeight="900"
          textAlign="center"
        >
          <span style={{ color: "green" }}>
            META APES UNIVERSE
            <br />
          </span>
          READY FOR NEW OPPORTUNITIES?
        </Text>
        <Text
          color="#fff"
          lineHeight="120%"
          marginBottom="10px"
          marginTop="20px"
          fontSize="18px"
        >
          <b>META APES UNIVERSE CLUB</b> is a project that will change the
          industry of NFT projects, with its new, stable, interesting and
          profitable opportunities for our users.
          <br />
          <br />
          <b>MAU team</b> creates its own online world, <b>MAUVERSE!</b>
          <br />
          <br />
          <b>In MAUVERSE</b> you will be able to live using your &nbsp;
          <b>NFT, study, work, play, communicate, create, earn daily</b>&nbsp;
          and much more!
          <br />
          <br />
          <b>MAU NFT'S</b> is not just digital art, it is primarily a high-tech
          gadget that will open up new opportunities for you in the&nbsp;
          <b>
            field of earnings, life, communications, education and
            entertainment.
          </b>
          <br />
          <br />
          We have also prepared MAU MOVE TO EARN opportunities for you!&nbsp;
          <b>META APES UNIVERSE</b> will be the first crypto project that will
          provide permanent online jobs in its online world MAUVERSE.
          <br />
          <br />
          Every <b>FIRST MAU NFT</b> owner will get a FREE&nbsp;
          <b>plot of land</b>&nbsp; in&nbsp;
          <b>MAUVERSE!</b>
          <br />
          <br />
          The sale of land plots will begin after the sold out of the&nbsp;
          <b>MAU NFT</b>&nbsp; collection.
          <br />
          <br />
          And much more is coming soon!
        </Text>
      </Box>
    </Flex>
  );
};

export default About;
